export { default as WarningAlert } from './warning-alert';
